// @flow

import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { VisaPlusProfile } from './async-loading'
import { ThemeProvider } from '@paypalcorp/pp-react'
import VisaPlusProfileStateContainer from './screens/visa-plus/container'

const overpanelViews = ['/visa-plus/onboard']

export default () => {
  return (
    <Route exact path={overpanelViews}>
      <Switch>
        <VisaPlusRoute
          exact
          path="/visa-plus/onboard"
          component={VisaPlusProfile}
          // customProps={{
          // }}
        />
        {/* NOTE: Remaining routes coming soon. */}
        <Route path="/visa-plus">
          <Redirect
            to={{
              pathname: '/my/landing',
            }}
          />
        </Route>
      </Switch>
    </Route>
  )
}

type ReactComponent = () => React.Element | React.Component

function VisaPlusRoute({
  component: Comp,
  customProps = {},
  ...props
}: {
  component: ReactComponent,
}) {
  return (
    <Route
      exact
      render={routerProps => (
        <>
          <ThemeProvider theme="v2">
            <VisaPlusProfileStateContainer
              {...routerProps}
              body={<Comp {...routerProps} {...customProps} />}
              // renderErrorScreen={}
            />
          </ThemeProvider>
        </>
      )}
      {...props}
    />
  )
}
